webpackJsonp([70144966829960],{

/***/ 616:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfhChYAMSY6XvAqAAAAuklEQVQoz6XRP0vCcRAG8I86Bc2+IAeFUqS9QIQkJ4egN9BsoIvQm2gUQhAn51oaDQKHUAoMUSu+DenvJ/hn8W65u+fguec5Do2EjPQefEzWk7AjX+T4cOZhK9xWNCL4UXO7Ad+pWgiW7b1z0wicq2gu62jYk/MmCN4VPK7myejeXyllfc8ufDuKhfxvNlyambhx7dNUSSummK0xxll3ZS4wlNfdKrOjYMip151GDZwk5B3vsfrr4Gf6A48Vgv89g3lqAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE3LTEwLTIyVDAwOjQ5OjM4KzAyOjAwcv42KgAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxNy0xMC0yMlQwMDo0OTozOCswMjowMAOjjpYAAAAZdEVYdFNvZnR3YXJlAHd3dy5pbmtzY2FwZS5vcmeb7jwaAAAAAElFTkSuQmCC"

/***/ }),

/***/ 618:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAQAAAC1+jfqAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAKqNIzIAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfhChYBCzGd5sGjAAAAzElEQVQoz4XRv0uCURTG8Y8GvYtIS9RkiwjR1OQQFP0DNTa29AcpuBS0O7S4CekQONUa9GMSnOPdQkO6DfbqfTPxPNN5vs85XM5lTW384+26UJdKUSbRtBnhE6kgGLvWs82pYGDnFxcMhbn6LqkJgpErFVmX6XY2dT83XrVzgTM48OA7Zy9UmW14W4E/sncfr4jcZYFEy3gJT9SgiIkXydK5Gt7j9lAnN/+ktIBbjtyYRrgR37auG6FPA+fx6gLYs6/qy6Nn03X/+6d+AN2jdxHvUX4AAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE3LTEwLTIyVDAxOjExOjQ5KzAyOjAwYVoBtAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxNy0xMC0yMlQwMToxMTo0OSswMjowMBAHuQgAAAAZdEVYdFNvZnR3YXJlAHd3dy5pbmtzY2FwZS5vcmeb7jwaAAAAAElFTkSuQmCC"

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(30);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _contactModule = __webpack_require__(342);
	
	var _contactModule2 = _interopRequireDefault(_contactModule);
	
	var _emailFilledClosedEnvelope = __webpack_require__(616);
	
	var _emailFilledClosedEnvelope2 = _interopRequireDefault(_emailFilledClosedEnvelope);
	
	var _twitterLogoSilhouette = __webpack_require__(618);
	
	var _twitterLogoSilhouette2 = _interopRequireDefault(_twitterLogoSilhouette);
	
	var _board = __webpack_require__(35);
	
	var _board2 = _interopRequireDefault(_board);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: "Contact | " + data.site.siteMetadata.title
	    }),
	    _react2.default.createElement(
	      _board2.default,
	      null,
	      _react2.default.createElement(
	        "h3",
	        null,
	        "\u304A\u554F\u3044\u5408\u308F\u305B\u5148"
	      ),
	      _react2.default.createElement(
	        "table",
	        null,
	        _react2.default.createElement(
	          "tbody",
	          null,
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              null,
	              _react2.default.createElement("img", { src: _emailFilledClosedEnvelope2.default })
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              "karuhiko1+mingaku@gmail.com"
	            )
	          ),
	          _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "th",
	              null,
	              _react2.default.createElement("img", { src: _twitterLogoSilhouette2.default })
	            ),
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(
	                "a",
	                { href: "https://twitter.com/karuhiko1", target: "__blank" },
	                "@karuhiko1"
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	var query = exports.query = "** extracted graphql fragment **";

/***/ }),

/***/ 342:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"contactBoard":"src-styles----contact-module---contactBoard---1tjCP"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-1c73081541e51b1b2348.js